import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center pa-5 bg-secondary" }
const _hoisted_2 = {
  class: "timeListBtn",
  id: "timeListBtn"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", null, "Show stats and times", -1)

import { ref, watch } from "vue";
import { type ScrambleType } from "@/js/types";

// props: ,

export default /*#__PURE__*/_defineComponent({
  __name: 'Scrambles',
  props: ["changeScramble", "disableInput", "disableInput2", "disableInput3", "timerRunning"],
  emits: ["new-scramble", "show-timelist"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

//* vars
const selectItems = [
    { value: "333", name: "3x3" },
    { value: "222", name: "2x2" },
    { value: "444", name: "4x4" },
    { value: "555", name: "5x5" },
    { value: "666", name: "6x6" },
    { value: "777", name: "7x7" },
    { value: "clock", name: "Clock" },
    { value: "minx", name: "Megaminx" },
    { value: "pyram", name: "Pyraminx" },
    { value: "skewb", name: "Skewb" },
    { value: "sq1", name: "Square-1" },
];

const Scrambow = require("scrambow").Scrambow;
let scrambleGen = new Scrambow();
let smallFont = ref<0 | 1 | 2 | 3>(0);
let scramble = ref<{ scramble_string: string }[]>(scrambleGen.get(1));
let scrambleText = ref<string>("");
changeScramble();
emit("new-scramble", scrambleText.value);
let scrambleType = ref<ScrambleType>("333");
let disableInput = ref<boolean>(false);
let disableInput2 = ref<boolean>(false);

//* watch if scramble type changes
watch(
    () => scrambleType.value,
    (scramType) => {
        if (props.timerRunning) return;
        scrambleGen = new Scrambow().setType(scramType);
        changeScramble();
        if (scramType === "555") {
            smallFont.value = 1;
        } else if (scramType === "666" || scramType === "minx") {
            smallFont.value = 2;
        } else if (scramType === "777") {
            smallFont.value = 3;
        } else {
            smallFont.value = 0;
        }
    },
);

//* change the scramble
function changeScramble() {
    if (props.timerRunning) return;
    scramble.value = scrambleGen.get(1);
    let scrambleArr: string[] = scramble.value[0].scramble_string.split(" ");
    scrambleArr = scrambleArr.filter((e) => {
        if (e === " " || e === "") {
            return false;
        }
        return true;
    });
    scrambleText.value = scrambleArr.join(" ");

    emit("new-scramble", scrambleText.value);
}

//* watch if you need to change scramble
watch(
    () => props.changeScramble,
    () => {
        changeScramble();
    },
);

function showTimeList() {
    const button = document.getElementById("timeListBtn");
    button!.blur();
    emit("show-timelist");
    disableInput2.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(disableInput2) === false)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "timeListBtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showTimeList())),
            color: "background"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_select, {
      label: "Scramble Type",
      items: selectItems,
      "item-title": "name",
      "item-value": "value",
      modelValue: _unref(scrambleType),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(scrambleType) ? (scrambleType).value = $event : scrambleType = $event)),
      density: "compact",
      "hide-details": "",
      class: "mb-1",
      disabled: props.disableInput || props.disableInput2 || props.disableInput3 || props.timerRunning
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("h2", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeScramble())),
      class: _normalizeClass(["cursor-pointer ma-0 text-color-white scramble-text", {
                smallFont555: _unref(smallFont) === 1,
                smallFont666: _unref(smallFont) === 2,
                smallerFont: _unref(smallFont) === 3,
            }]),
      style: {"user-select":"none"}
    }, _toDisplayString(_unref(scrambleText)), 3)
  ]))
}
}

})